<template>
    <PageWrapper>
        <template #headline>
            <div class="flex h-auto w-full items-center justify-between">
                <div class="flex items-center gap-2">
                    <fa icon="fa-money-bill" />
                    {{ $t('taxes') }}
                </div>
            </div>
        </template>
        <TaxesTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import TaxesTable from '@src/partials/taxes/TaxesTable.vue'
</script>
